import stylex from '@stylexjs/stylex';

import type { IContainerProps } from '~/components/utils/Container';

export type ITableBodyProps = IContainerProps & {
  children?: React.ReactNode;
};

const styles = stylex.create({
  host: {
    display: 'flex',
    padding: '1rem',
    alignItems: 'flex-start',
  },
});

export const TableBody: React.FC<ITableBodyProps> = ({
  children,
  ...props
}) => <div {...stylex.props(styles.host, props.sx)}>{children}</div>;
